module.exports = __webpack_public_path__ + "static/media/couch.f700c53e.svg";